<template>
  <div class="dialog-wrap">
    <el-dialog
      title="菜单位置添加"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px">
      <el-form class="form" :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
        <el-form-item label="位置名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="请输入位置名称"></el-input>
        </el-form-item>
        <el-form-item label="位置编码" prop="code">
          <el-input v-model="dataForm.code" placeholder="请输入位置编码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { menuPositionCreate } from '@/api/operation'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      rules: {
        name: [{ required: true, message: '请输入位置名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入位置编码', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm)
          menuPositionCreate(params).then(res => {
            this.$message.success(`添加成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .form {
      margin-bottom: -18px;
    }
  }
</style>
